import { FONT_FAMILY, LCD } from "../config";
import type { ViewLayout } from "./layout";

export interface DrawContext {
  ctx: CanvasRenderingContext2D;
  layout: ViewLayout;
}

/** Pixel fontla metin çizer. */
export function drawText(
  rc: DrawContext,
  str: string,
  x: number,
  y: number,
  size: number,
  align: CanvasTextAlign = "center",
  color: string = LCD.dark,
): void {
  const { ctx } = rc;
  ctx.font = `${size}px ${FONT_FAMILY}`;
  ctx.textAlign = align;
  ctx.textBaseline = "middle";
  ctx.fillStyle = color;
  ctx.fillText(str, x, y);
}
